import consumer from "./consumer"

import { cardImportChannelId, cardImportChannelMethods } from './card_import_channel'
// ...

let cardImportSubscription
// ...
document.addEventListener("turbo:load", () => {
  // 1. try reconnect (login)
  if(consumer.connection.disconnected) consumer.connect()

  // 2. subscribe channel(s)
  if(!cardImportSubscription) {
    cardImportSubscription = consumer.subscriptions.create(cardImportChannelId, cardImportChannelMethods)
  }
  // ...
})